<template>
  <div>
    <el-card shadow="never">
      <div slot="header">
        <span class="title">基本信息</span>
        <el-button v-show="!isClick" type="primary" plain class="title-btn" @click="cancel">返回</el-button>
      </div>
      <div style="width: 600px;">
        <el-form ref="ruleForm" :model="form" :rules="isClick?rules:{}" label-width="100px">
          <el-form-item label="任务名称" prop="taskName">
            <el-input v-model="form.taskName" :disabled="!isClick" placeholder="请输入任务名称" />
          </el-form-item>
          <el-form-item label="任务模式" prop="taskType">
            <el-radio-group v-model="form.taskType" :disabled="!isClick">
              <el-radio label="0">补贴下发</el-radio>
              <el-radio label="1">补贴扣回</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="金额" prop="money">
            <el-input v-model="form.money" :disabled="!isClick" placeholder="请输入金额" style="width: calc(100% - 100px);" />&nbsp;&nbsp;元
          </el-form-item>
          <el-form-item label="执行时间" prop="executeTime">
            <el-date-picker
              v-model="form.executeTime"
              type="datetime"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              placeholder="选择时间"
              :disabled="!isClick"
            />
          </el-form-item>
          <el-form-item label="执行目标" prop="executeObject">
            <el-radio-group v-model="form.executeObject" :disabled="!isClick" @change="userCancelTree()">
              <el-radio v-for="(item, index) in userTypeItem" :key="index" :label="item.id">{{ item.label }}</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item :label="form.executeObject==='0'?'选择标签':form.executeObject==='1'?'选择企业':'选择用户'" prop="persons">
            <!-- 选择标签 -->
            <div v-show="form.executeObject==='0'" class="border">
              <el-input v-show="isClick" v-model="filterTagText" placeholder="输入关键字进行过滤" />
              <el-tree
                ref="treeTag"
                :data="tagTreeData"
                show-checkbox
                default-expand-all
                node-key="id"
                highlight-current
                :default-checked-keys="form.persons"
                :props="treeDefaultProps"
                :filter-node-method="filterNode"
                @check-change="handleTagChange"
              />
            </div>
            <!-- 选择企业-->
            <div v-show="form.executeObject==='1'" class="border">
              <el-input v-show="isClick" v-model="filterMechanismText" placeholder="输入关键字进行过滤" />
              <el-tree
                ref="treeMechanism"
                :data="mechanismTreeData"
                show-checkbox
                default-expand-all
                node-key="id"
                highlight-current
                :default-checked-keys="form.persons"
                :props="treeDefaultProps"
                :filter-node-method="filterNode"
                :check-strictly="true"
                @check-change="handleMechanismChange"
              />
            </div>
            <!-- 选择用户 -->
            <div v-show="form.executeObject==='2'" class="border">
              <el-input v-show="isClick" v-model="filterUserText" placeholder="输入关键字进行过滤" />
              <el-tree
                ref="treeUser"
                :data="userTreeData"
                show-checkbox
                default-expand-all
                node-key="id"
                highlight-current
                :default-checked-keys="form.persons"
                :props="treeDefaultProps"
                :filter-node-method="filterNode"
                @check-change="handleUserChange"
              />
            </div>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <el-card v-if="!isClick" shadow="never">
      <div slot="header">
        <span class="title">发放记录</span>
      </div>
      <STable
        ref="detailTableref"
        :url="url"
        :columns="columns"
        :query="query"
        :selection="false"
        :toolbar="toolbar"
        label-width="100px"
      />
    </el-card>
    <div v-show="isClick" class="flexJCenter mt-25">
      <el-button @click="cancel">取消</el-button>
      <el-button type="primary" @click="onSubmit()">保存</el-button>
    </div>
  </div>
</template>

<script>
import { HOST } from '@/utils/host'
import { treeDisabled } from '@/utils/tool'
export default {
  data() {
    var validateDate = (rule, value, callback) => {
      if (Date.parse(new Date()) > Date.parse(value) || Date.parse(new Date()) === Date.parse(value)) {
        callback(new Error(`执行时间不能小于当前时间`))
      } else {
        callback()
      }
    }
    return {
      isClick: 1,
      form: {
        id: '',
        taskName: '',
        taskType: '',
        money: '',
        executeTime: '',
        executeObject: '0',
        persons: []
      },
      rules: {
        taskName: [
          { required: true, message: '请输入任务名称', trigger: 'blur' }
        ],
        taskType: [
          { required: true, message: '请选择任务模式', trigger: 'change' }
        ],
        money: [
          { required: true, message: '请输入金额', trigger: 'blur' },
          { validator: (rule, value, callback) => {
            if (/^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/.test(value) === true || Number(value) === 0) {
              callback()
            } else {
              callback(new Error('请输入正数'))
            }
          },
          trigger: 'blur'
          }
        ],
        executeTime: [
          { required: true, message: '请选择执行时间', trigger: 'change' },
          { validator: validateDate, trigger: 'change' }
        ],
        executeObject: [
          { required: true, message: '请选择执行目标', trigger: 'change' }
        ],
        persons: [
          { required: true, message: '请选择数据', trigger: 'change' }
        ]
      },
      treeDefaultProps: {
        children: 'children',
        label: 'name'
      },
      filterMechanismText: '', // 机构过滤
      filterTagText: '', // 标签过滤
      filterUserText: '', // 用户过滤
      userTreeData: [], // 用户树数据
      mechanismTreeData: [], // 企业树数据
      tagTreeData: [], // 标签树数据
      userTypeItem: [
        {
          label: '标签',
          id: '0'
        }, {
          label: '企业',
          id: '1'
        }, {
          label: '用户',
          id: '2'
        }
      ],
      url: '/admin/subsidy/detailPageSubsidy',
      columns: [
        {
          label: '所属企业',
          prop: 'orgName'
        },
        {
          label: '用户账号',
          prop: 'account'
        },
        {
          label: '用户姓名',
          prop: 'personName'
        },
        {
          label: '手机号',
          prop: 'phone'
        },
        {
          label: '金额',
          prop: 'money',
          template: (index, reocrd) => {
            return this.getFixed2(reocrd.money) + '元'
          }
        },
        {
          label: '发放时间',
          prop: 'executeTime'
        }
      ],
      query: [
        {
          label: '所属企业',
          prop: 'orgName',
          placeholder: '请输入企业名称'
        }, {
          label: '用户账号',
          prop: 'account',
          placeholder: '请输入用户账号'
        }, {
          label: '手机号',
          prop: 'phone',
          placeholder: '请输入手机号'
        }, {
          label: '发放时间',
          prop: 'executeTime',
          placeholder: '',
          type: 'date2'
        }
      ],
      toolbar: [
        {
          label: '导出',
          icon: 'el-icon-download',
          type: 'primary',
          handle: (resp) => {
            const url = HOST + '/admin/subsidy/exportSubsidyIssueList?subsidyId=' + this.form.id
            const data = this.$refs.detailTableref.getQueryData()
            $.fileDownload(url, {
              httpMethod: 'GET',
              data: {
                token: window.localStorage.getItem('token'),
                ...data
              },
              failCallback: (html, url) => {
                this.$notify({
                  title: '失败',
                  message: '导出发放记录失败',
                  type: 'error'
                })
              }
            })
          }
        }
      ]
    }
  },
  watch: {
    filterTagText(val) {
      this.$refs.treeTag.filter(val)
    },
    filterMechanismText(val) {
      this.$refs.treeMechanism.filter(val)
    },
    filterUserText(val) {
      this.$refs.treeUser.filter(val)
    }
  },
  beforeMount() {
    if (this.$route.query.id) {
      this.form.id = this.$route.query.id
      this.url = '/admin/subsidy/detailPageSubsidy?subsidyId=' + this.form.id
    }
  },
  mounted() {
    // 查询全部标签方法
    this.getTagTree()
    // 查询全部企业方法
    this.getMechanismTree()
    // 查询全部用户方法
    this.getUserTree()
    if (this.$route.query.id) {
      this.getDataDetail(this.$route.query.id)
    }
    this.isClick = Number(this.$route.query.isclick)
  },
  methods: {
    // 获取权益详细信息
    getDataDetail(id) {
      const data = {
        id: id
      }
      this.$store.dispatch('form/handle', {
        url: '/admin/subsidy/getSubsidyById',
        data: data,
        method: 'post',
        callback: resp => {
          this.form = {
            id: resp.id,
            taskName: resp.taskName,
            taskType: resp.taskType,
            money: resp.money,
            executeTime: resp.executeTime,
            executeObject: resp.executeObject,
            persons: resp.executeIds ? resp.executeIds : []
          }
        }
      })
    },
    // 查询全部企业树的数据
    getMechanismTree() {
      this.$store.dispatch('form/handle', {
        url: '/setting/tree/org',
        data: { orgType: '1,3' },
        callback: resp => {
          if (this.$route.query.isclick === '0') {
            this.mechanismTreeData = treeDisabled(resp, true)
          } else {
            this.mechanismTreeData = resp
          }
        }
      })
    },
    // 查询全部标签树的数据
    getTagTree() {
      this.$store.dispatch('form/handle', {
        url: '/user/label/all',
        data: { orgType: '1,3', labelType: '0' },
        callback: resp => {
          if (this.$route.query.isclick === '0') {
            this.tagTreeData = treeDisabled(resp, true)
          } else {
            this.tagTreeData = resp
          }
        }
      })
    },
    // 查询全部用户树的数据
    getUserTree() {
      this.$store.dispatch('form/handle', {
        url: '/business/whitelist/getOrgAndUser',
        method: 'get',
        callback: resp => {
          if (this.$route.query.isclick === '0') {
            this.userTreeData = treeDisabled(resp, true)
          } else {
            this.userTreeData = resp
          }
        }
      })
      // this.$store.dispatch('form/handle', {
      //   url: '/setting/tree/user',
      //   data: { orgType: '1,3' },
      //   callback: resp => {
      //     if (this.$route.query.isclick === '0') {
      //       this.userTreeData = treeDisabled(resp, true)
      //     } else {
      //       this.userTreeData = resp
      //     }
      //   }
      // })
    },
    // 树的节点筛选
    filterNode(value, data, node) {
      if (!value) return true
      let parentNode = node.parent
      let labels = [node.label]
      let level = 1
      while (level < node.level) {
        labels = [...labels, parentNode.label]
        parentNode = parentNode.parent
        level++
      }
      return labels.some(label => label.indexOf(value) !== -1)
    },
    // 切换执行目标时 取消树的选择
    userCancelTree() {
      this.$refs.treeMechanism.setCheckedKeys([])
      this.$refs.treeTag.setCheckedKeys([])
      this.$refs.treeUser.setCheckedKeys([])
    },
    // 选择企业 赋值
    handleMechanismChange(data, checked, indeterminate) {
      this.form.persons = this.$refs.treeMechanism.getCheckedKeys()
    },
    // 选择标签 赋值
    handleTagChange(data, checked, indeterminate) {
      this.form.persons = this.$refs.treeTag.getCheckedKeys()
    },
    // 选择用户 赋值
    handleUserChange(data, checked, indeterminate) {
      this.form.persons = this.$refs.treeUser.getCheckedKeys()
    },
    onSubmit() {
      let ruleFormBool = false
      this.$refs['ruleForm'].validate(valid => {
        ruleFormBool = valid
      })

      // 表单校验通过
      if (ruleFormBool) {
        const data = JSON.parse(JSON.stringify(this.form))
        data.persons = this.form.persons.join(',')
        data.enable = true
        if (data.id) {
          this.$store.dispatch('form/handle', {
            url: '/admin/subsidy/updateSubsidyById',
            data: data,
            method: 'post',
            callback: resp => {
              this.$router.go(-1)
            }
          })
        } else {
          this.$store.dispatch('form/handle', {
            url: '/admin/subsidy/add',
            data: data,
            method: 'post',
            callback: resp => {
              this.$router.go(-1)
            }
          })
        }
      }
    },
    cancel() {
      this.$router.go(-1)
    }
  }
}
</script>

<style scoped lang="less">
    .flexJCenter{
        display: flex;
        justify-content: center;
    }
    .mt-25{
        margin-top: 25px;
    }
    .border{
      border: 1px solid #EEEEEE;
      padding: 20px;
      height: 300px;
      overflow-y: auto;
    }
</style>



// WEBPACK FOOTER //
// src/views/userManagement/subsidyEdit.vue